export enum Sexo {
    Masculino = 1,
    Femenino = 2
}